// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef } from 'react';
import styled from 'styled-components';

interface LoadingProps extends ComponentPropsWithRef<'div'> {
  size?: number;
  contentOrientation?: string
}

const LoadingIcon = (props:LoadingProps): JSX.Element => {
  const {
    size = 60,
    contentOrientation = 'flex-start'
  } = props;
  return (
    <S.Container size={size} contentOrientation={contentOrientation}>
      <S.LoadingBar delay={1} size={size} />
      <S.LoadingBar delay={2} size={size} />
      <S.LoadingBar delay={3} size={size} />
    </S.Container>
  )
}

const COLOR1 = '#FFEFDC';
const COLOR2 = '#FFE1BD';
const COLOR3 = '#FFC683';

const S = {
  Container: styled.div<{ size: number, contentOrientation: string}>`
    display: flex;
    padding: ${props => props.size >= 5 ? '20px' : '0 8px'};
    justify-content: ${props => props.contentOrientation};
    > * + * {
      margin-left: ${props => props.size * 0.75}px;
    }
  `,
  LoadingBar: styled.div<{ delay: number, size: number }>`
    width: ${props => props.size}px;
    height: ${props => props.size * 3}px;
    border-top-right-radius: ${props => props.size}px;
    border-bottom-left-radius: ${props => props.size}px;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    background-color: ${COLOR1};
    transform: translateY(12.5%);

    animation-name: bounce;
    animation-delay: ${props => (props.delay - 1) * 0.3}s;

    @keyframes bounce {
      from {
        background-color: ${COLOR1};
        transform: translateY(12.5%);
      }

      25% {
        transform: translateY(12.5%);
        background-color: ${COLOR2};
      }

      50% {
        transform: translateY(-12.5%);
        background-color: ${COLOR3};
      }

      75% {
        transform: translateY(12.5%);
      }

      to {
        transform: translateY(12.5%);
      }
    }
  `
}

export default LoadingIcon;
